export const getPrivateChatSelector = state => state.privateChat;
